"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M12 3 4 9v12h16V9zm4 13.06L14 15v2H8v-6h6v2l2-1.06z"
}), 'CameraIndoorSharp');